import de from "dayjs/locale/de";
import es from "dayjs/locale/es-mx";
import en from "dayjs/locale/en";
import fr from "dayjs/locale/fr";

export const localeSelected = (locale: string) => {
  if (locale === "fr") {
    return fr;
  }
  if (locale === "de") {
    return de;
  }

  if (locale === "es") {
    return es;
  } else {
    return en;
  }
};

export const manageFormat = (locale: string) => {
  if (locale === "fr") {
    return "DD/MM/YYYY";
  }
  if (locale === "es") {
    return "DD/MM/YYYY";
  }
  if (locale === "de") {
    return "DD/MM/YYYY";
  } else {
    return "MM/DD/YYYY";
  }
};
